import { render } from "./visitorCard.vue?vue&type=template&id=db8548e4"
import script from "./visitorCard.vue?vue&type=script&lang=js"
export * from "./visitorCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__